import {PayloadAction} from "@reduxjs/toolkit";
import {notification, Spin} from "antd";
import React from "react";
import {call, put, takeEvery} from "redux-saga/effects";
import {UPDATE_USER, usersActions} from "../../actions/index";
import {UpdateUserParams, usersApi} from "../../api/index";
import {setUsersActionStatus} from "../../usersSlice";

function* updateUserWorker(action: PayloadAction<UpdateUserParams>) {
  yield put(setUsersActionStatus({name: "updateUser", status: "pending"}));
  notification.open({
    key: "loading",
    message: "Загрузка...",
    icon: <Spin />
  });
  try {
    yield call(usersApi.update, action.payload);
    yield put(usersActions.getById(action.payload.userId));
    yield put(setUsersActionStatus({name: "updateUser", status: "fulfilled"}));
    notification.close("loading");
    notification.success({
      message: "Пользователь успешно обновлен."
    });
  } catch (error: any) {
    notification.close("loading");
    notification.error({
      message: "При обновлении пользователя произошла ошибка."
    });
    yield put(setUsersActionStatus({name: "updateUser", status: "rejected"}));
  }
}

function* updateUserWatcher() {
  yield takeEvery(UPDATE_USER, updateUserWorker);
}

export default updateUserWatcher;
